import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import ExportSelectedServiceOrdersForm from './ExportSelectedServiceOrdersForm'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'

const ExportSelectedServiceOrdersModal = props => {
  return (
    <ControlledModal width="32rem" disableClickOutside {...props}>
      <MultiSelectHandler>
        <PermissionChecker permission="exportServiceOrder">
          <ModalHeader />
          <ExportSelectedServiceOrdersForm />
        </PermissionChecker>
      </MultiSelectHandler>
    </ControlledModal>
  )
}

export default ExportSelectedServiceOrdersModal
